// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:479px){.title[data-v-65cefb4c]{font-weight:400px;font-size:var(--font-size-title-micro)}}", ""]);
// Exports
module.exports = exports;
